<template>
  <v-select
    v-model="select"
    :label="$t('byTypeOfUser')"
    :items="selectItems"
    item-text="text"
    item-value="value"
    prepend-icon="mdi-account-details"
    dense
    filled
    hide-details
    solo-inverted
    @change="setSelectUserLogLevel"
  ></v-select>
</template>
<script>
export default {
  name: "components-common-filters-select-type-User",
  data: () => ({
    // V-select
    select: "backoffice",
  }),
  computed: {
    selectItems() {
      return [
        {
          text: this.$t("backOffice"),
          value: "backoffice",
        },
        {
          text: this.$t("collaborator"),
          value: "collaborator",
        },
        {
          text: this.$t("agent"),
          value: "agent",
        },
        {
          text: this.$t("player"),
          value: "player",
        },
      ];
    },
  },
  methods: {
    setSelectUserLogLevel(value) {
      this.$store.commit("setSelectUserLogLevel", value);
    },
  },
};
</script>
